<template>
  <section class="upload-files">
    <b-field>
      <b-upload v-model="files" multiple drag-drop expanded>
        <section class="section">
          <div class="content has-text-centered">
            <p>
              <b-icon icon="upload" size="is-large"></b-icon>
            </p>
            <p>Drop your files here or click to upload</p>
          </div>
        </section>
      </b-upload>
    </b-field>

    <div class="tags">
      <span v-for="(file, index) in files" :key="index" class="tag is-secondary">
        {{ file.name }}
        <button class="delete is-small" type="button" @click="deleteDropFile(index)"></button>
      </span>
    </div>
    <div class="special-instructions">
      <b-message type="is-danger" has-icon>
        Please make sure the following are uploaded: Floor Plans, Section Drawings and Elevations
      </b-message>
      <b-message type="is-info" has-icon>
        If you have any other information regarding the project please upload with your plans
      </b-message>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      files: [],
    };
  },
  methods: {
    deleteDropFile(index) {
      this.files.splice(index, 1);
    },
    clearFiles() {
      this.files = [];
    }
  }
};
</script>

<style scoped lang="scss">
.upload-files {
  .special-instructions {
    margin-top: 1rem;
    margin-bottom: 1.75rem;
    font-size: 0.8rem;
    display: flex;
    flex-direction: column;
  }
}
</style>